module.exports = __webpack_public_path__ + "img/default_template.fbc2308e.png";